import React from 'react';
import { usePublicSettings } from '@/hooks/usePublicSettings';

const FooterLogo = () => {
  const { config, loading } = usePublicSettings();

  // Don't render if loading or logo is disabled
  if (loading || !config.show_logo) {
    return null;
  }

  return (
    <div className="flex justify-center pt-8 pb-4">
      <img
        src={config.logo_url}
        alt="Museum logo"
        className="h-32 max-w-64 object-contain opacity-70 transition-opacity hover:opacity-100"
        onError={(e) => {
          e.currentTarget.src = '/placeholder.svg';
        }}
      />
    </div>
  );
};

export default FooterLogo;